import { Module } from 'vuex-smart-module';
import BlackListActions from './actions';
import BlackListGetters from './getters';
import BlackListMutations from './mutations';
import BlackListState from './state';

export default new Module({
  state: BlackListState,
  mutations: BlackListMutations,
  actions: BlackListActions,
  getters: BlackListGetters,
});
